import Vue from 'vue';
import { ReportState } from '@/store';

// eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
export const reportSet = (state: ReportState, report: any): void => {
  Vue.set(state.reports, report.documentId, report.payload);
};
